
import axios from 'axios';
import Store from "../store/store";

const requestUser = Store.dispatch("getAuthUser");

export default function () {
    return axios.all([requestUser])
}
